import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './style.css';
import App from './App';

createRoot(document.getElementById('react-app')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
